<style scoped>
    .page_box{
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .ivu-page{
        margin-right: 20px;
    }
</style>
<template>
    <Row class="page_box">
        <Page :total="total" show-elevator show-sizer show-total :page-size="pageSize" :current.sync="currentpage" @on-change="pagechange" @on-page-size-change="pagesizechange" ref="page" />
        <Button type="primary" @click="confirm">确定</Button>
    </Row>
</template>
<script>
import {
    Page
} from 'iview';

export default {
    data() {
        return {
            pageSize: 10,
            total:0,
            currentpage: 1,

        }
    },
    props: ['totalNum', 'pageNum'],
    watch: {
        totalNum: function() {
            this.total = this.totalNum
        },
        pageNum: function() {
            this.currentpage = this.pageNum
        },
    },

    methods: {
        //分页 页码改变的回调，返回改变后的页码
        pagechange(num) {
            this.currentpage = num
            this.$emit('changePage', this.currentpage)
        },
        //分页  切换每页条数时的回调，返回切换后的每页条数
        pagesizechange(num) {
            this.pageSize = num
            this.$emit('changePageSize', this.pageSize)
        },
        //点击直接跳到相应的页
        confirm() {
            let inpValue = this.$refs.page.$el.lastElementChild.lastElementChild.childNodes[1].value;
            if (inpValue == "") {
                this.$Message.info('请填写页数');
                return false;
            } else if (inpValue > Math.ceil(this.total / this.pageSize)) {
                this.$Message.info('超过总页数，无法跳转');
                this.$refs.page.$el.lastElementChild.lastElementChild.childNodes[1].value = this.currentpage;
                return false;
            } else {
                this.currentpage = Number(inpValue)
                this.$emit('clickPage', this.currentpage)

            }


        }
    },
    created() {
        if (this.totalNum) {
            this.total = this.totalNum
        }
    },
    components: {
        Page
    },
};
</script>